<template>
  <div>
    <showdatausercomponents />
  </div>
</template>

<script>
import showdatausercomponents from "@/components/showdatausercomponents.vue";
export default {
  components: { showdatausercomponents},
};
</script>
